import { getTodayDateString, getStartOfWeek, getEndOfWeek, getStartOfMonth, getEndOfMonth } from '../../../utils/dateHelpers';

interface DateFilterProps {
  startDate: string;
  endDate: string;
  onStartChange: (val: string) => void;
  onEndChange: (val: string) => void;
  onPreset: (preset: string) => void;
  activePreset: string;
}

const presets = [
  { label: 'Today', value: 'today' },
  { label: 'This Week', value: 'week' },
  { label: 'This Month', value: 'month' },
  { label: 'All', value: 'all' },
];

export default function DateFilter({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  onPreset,
  activePreset,
}: DateFilterProps) {
  const handlePresetClick = (preset: string) => {
    onPreset(preset);
    
    // Automatically update date inputs based on preset
    switch (preset) {
      case 'today':
        const today = getTodayDateString();
        onStartChange(today);
        onEndChange(today);
        break;
      case 'week':
        onStartChange(getStartOfWeek());
        onEndChange(getEndOfWeek());
        break;
      case 'month':
        onStartChange(getStartOfMonth());
        onEndChange(getEndOfMonth());
        break;
      case 'all':
        onStartChange('');
        onEndChange('');
        break;
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5">
      <h3 className="text-sm font-semibold text-gray-900 mb-3 flex items-center space-x-2">
        <i className="ri-calendar-2-line w-4 h-4 flex items-center justify-center text-teal-600"></i>
        <span>Filter by Date</span>
      </h3>

      {/* Quick presets */}
      <div className="flex flex-wrap gap-2 mb-4">
        {presets.map((p) => (
          <button
            key={p.value}
            onClick={() => handlePresetClick(p.value)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
              activePreset === p.value
                ? 'bg-teal-600 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {p.label}
          </button>
        ))}
      </div>

      {/* Custom date range */}
      <div className="space-y-3">
        <div>
          <label className="block text-xs text-gray-500 mb-1">From</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => onStartChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
          />
        </div>
        <div>
          <label className="block text-xs text-gray-500 mb-1">To</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => onEndChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
          />
        </div>
      </div>
    </div>
  );
}